import React, { useState, useCallback } from 'react'
import MBDrawer from 'components/@extended/MBDrawer'
import { Grid, Tab, Tabs, useTheme } from '@mui/material'
import MapPortfolioAccountsDrawerContent from './MapPortfolioAccountsDrawerContent'
import EditPortfolio from './EditPortfolio'

const createStyles = (theme) => ({
  headerContainer: {
    height: '48px',
    pr: '1rem',
    backgroundColor: theme.palette.secondary.light,
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
  },
})

const tabsProps = (index) => {
  return {
    id: `portfolio-manager-${index}`,
  }
}

export default function PortfoliosManager({
  portfolio,
  isOpenPortfolio,
  setIsOpenPortfolio,
  isAdminOrOwner,
}) {
  const theme = useTheme()
  const styles = createStyles(theme)

  const [tab, setTab] = useState(1)

  const handleChange = useCallback((event, newValue) => {
    setTab(newValue)
  }, [])

  const handleClose = useCallback(() => {
    setIsOpenPortfolio(false)
  }, [setIsOpenPortfolio])

  return (
    <MBDrawer
      open={isOpenPortfolio}
      onClose={() => setIsOpenPortfolio(false)}
      width="38%"
      title={
        <Tabs value={tab} onChange={handleChange}>
          <Tab label="Portfolio Details" {...tabsProps(0)} />
          <Tab label="Map" {...tabsProps(1)} />
        </Tabs>
      }
      headerContainerSx={styles.headerContainer}
      headerSX={{ p: 0 }}
    >
      <Grid container height={'100%'}>
        <Grid item xs={12} height={'100%'}>
          <Grid container height={'100%'}>
            {tab === 0 && (
              <Grid item xs={12} height={'100%'}>
                <EditPortfolio
                  portfolio={portfolio}
                  onSave={handleClose}
                  isAdminOrOwner={isAdminOrOwner}
                />
              </Grid>
            )}
            {tab === 1 && (
              <Grid item xs={12} height={'100%'}>
                <MapPortfolioAccountsDrawerContent portfolio={portfolio} onSave={handleClose} />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </MBDrawer>
  )
}
